import { useEffect } from "react";
import axios from "../utils/axios";

const REFRESH_INTERVAL_MINUTES = 14; // Adjust depending on access token expiry

const useTokenRefresh = (user) => {
  useEffect(() => {
    let interval;

    const refreshAccessToken = async () => {
      try {
        await axios.post("/auth/refresh-token");
        // console.info("Access token refreshed");
      } catch (err) {
        console.warn("Failed to refresh token", err);
        // Optional: handle logout or notification here if needed
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && user) {
        refreshAccessToken();
      }
    };

    if (user) {
      interval = setInterval(
        refreshAccessToken,
        REFRESH_INTERVAL_MINUTES * 60 * 1000
      );
      document.addEventListener("visibilitychange", handleVisibilityChange);
    }

    return () => {
      if (interval) clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [user]);
};

export default useTokenRefresh;
